import React, { useCallback } from 'react';
import { HeaderTemplate, Stepper, TitleHeader } from 'web-library';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import RouteKey from '../../../routes/key';
import IndividualReportContent from '../../../modules/accessArrangment/components/candidate/IndividualReport/components/IndividualReportContent';

const {
  root,
  reviewApplication,
  ammendAccessArrangements,
  accessArrangementsRequest,
} = RouteKey['access-arrangement'].child;
const { accessArrangement } = RouteKey.child;

interface IndividualReportPageProps {
  routeSteps: { label: string }[];
  activeStep: number;
  title?: string;
}

const IndividualReportPage = ({
  routeSteps,
  activeStep,
  title = '',
}: IndividualReportPageProps) => {
  const history = useHistory();
  const location = useLocation<{ amendment?: boolean }>();
  const amendment = location.state?.amendment ?? false;
  const { uuid } = useParams<{ uuid: string }>();

  const handleBack = () => {
    if (amendment) {
      history.push(`/${accessArrangement}/${root.route}/${ammendAccessArrangements.route}/${uuid}`);
    } else {
      history.push(`/${accessArrangement}/${root.route}/${accessArrangementsRequest.route}/${uuid}`);
    }
  };

  const onSuccess = useCallback(() => {
    history.push(
      `/${accessArrangement}/${root.route}/${reviewApplication.route}/${uuid}/${amendment ? 'amendment' : 'draft'}`
    );
  }, [history, uuid, amendment]);

  return (
    <>
      <TitleHeader title={title} />
      <HeaderTemplate>
        <Stepper activeStep={activeStep} steps={routeSteps} />
      </HeaderTemplate>
      <IndividualReportContent handleBack={handleBack} onSuccess={onSuccess} amendment={amendment} />
    </>
  );
};

export default IndividualReportPage;
